<template>
<div>

<div  class="modal" id="modalEpsonFiscalReceiptSingleUseVoucher"tabindex="-1" data-backdrop="static" data-keyboard="false" >
<div class="modal-dialog modal-dialog-centered"> 


<div  class="modal-content border border-success">

<div  style="background-color:#9acd32;color:black" class="modal-header border border-success text-nowrap ">
  <h4 class="modal-title ">
    <i style="color:blue" class="fas fa-cash-register mr-3" aria-hidden="true"></i>     
    <strong>STAMPA SCONTRINO FISCALE COUPON EMESSO</strong>
  </h4>  
</div>


<div  v-if="fiscalPrinter.fpId"  class="modal-body border border-success">
  <span style="color:red" v-if="msg.title"> {{ msg.body }}</span>

  <!--<alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>-->
</div>
<div v-else class="modal-body border border-success">
    <div class="d-flex justify-content-center">
  <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>




</div>



<div class="modal-footer">
 
     <button @click="closeModal()" type="button" class="btn btn-secondary ">
      <i class="fas fa-reply mr-2" aria-hidden="true"></i>
        ANNULLA
    </button>

    <button v-if="fiscalPrinter.fpId==1" @click="postXML()" :disabled="bt_spinner==true" type="button" class="btn btn-primary ">
          <i class="fas fa-print mr-2" aria-hidden="true"></i>   
            STAMPA 
          <span v-if="bt_spinner"  class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
    </button>    

    

</div>
</div>




</div>
</div>
</div>

</template>

<script>

import { mapGetters } from 'vuex';

import api               from '@/api'
import axios             from 'axios'
import alertBox          from '@/components/common/AlertBox.vue'

import fmt               from '@/components/mixins/fmt'



  export default {
  mixins : [fmt],
  props  : ['coupon'],

     components: {alertBox},
    data () {
      return {
        
          msg      : {title : '',body:'',type :0},
        
          deskId      : 1,  
          items       : [],
        
          bt_spinner  : false,
        
          fiscalPrinter : {}
                                   
      }
    },
    computed: 
  {
   ...mapGetters(['storeId','company']) ,   
      
     
  },
      
    created () 
      {
        
        this.$nextTick(()  => {                  
            $('#modalEpsonFiscalReceiptSingleUseVoucher').modal('show')
        
            })   
        
            const deskId = JSON.parse(localStorage.getItem("deskId"))    
            if(deskId)
            {    
              this.deskId = Number(deskId)
    
            }
        this.getFiscalPrinter()        
      },
    
    methods: 
    {
    
    async getFiscalPrinter()
    {
    

    const sp    = {'sp':'spStoreDeskFiscalPrinter'}
    const data  = {'storeId':this.storeId,'deskId':this.deskId}      
    const json  = Object.assign(data, sp)
      
      //this.bt_spinner = true
      await api.post(json).then(res => {
      if(res.status==200)
        {
          
         if(res.data.recordsets[0].length > 0) 
         {
            this.fiscalPrinter = res.data.recordsets[0][0]
            
         }
         console.log('FISCAL PRINTER ',this.fiscalPrinter)
        }
        else if(res.status==500)
        {
         
     
        
        } 
        else
        {
          
        
        } 
    }).catch(err => 
    {
      
     
       
    }).finally(() => {
      
    });

  

   },

    closeModal()
    {
        $('#modalEpsonFiscalReceiptSingleUseVoucher').modal('hide')
        this.$nextTick(()  => {              
        this.$emit('close')        
    })    
    },  

     getXML() 
     {
        
        let xml = ''  
          
        let total = 0
        this.coupon[1].forEach(item=>{
              if(item.typeId == 'CASH')  
              {
                total += item.total
              }

              if(item.typeId == 'ELEC')
              {
                total += item.total
              }

              
        })  
                    
        xml = '<printerFiscalReceipt> <beginFiscalReceipt  operator="1" />'
        xml += '<Printer Num="1" />'
        xml += '<printRecItem operator="1" description="COUPON MONO USO" quantity="1" unitPrice="' + total + '" justification = "1" />'            
        xml += '<printRecSubtotal operator="1" Type="1"/>'
        xml += '<printBarCode operator="1" position="901" width="3" height="120" HRIPosition="1" HRIFont="A" codeType="67" code="' + this.coupon[0][0].barcode + '"/>'         

     
        this.coupon[1].forEach(item => {
            if(item.typeId == 'CASH')
            {          
              xml += '<printRecTotal operator="1" description="Pagamento contante" amount="' + item.total + '" Type="0" index="3" justification = "2" />'
            }
            if(item.typeId == 'ELEC')
            {
                xml += '<printRecTotal operator="1" description="Pagamento elettronico" amount="' + item.total + '" Type="2" index="1" justification = "2" />'                  
            }
            
          })  

          xml += '<endFiscalReceipt  operator="1" /></printerFiscalReceipt>'
          
          console.log('EPSON FISCAL RECEIPT VOUCHER ',xml)  
          return xml              
      },
   
      getSOAP(xml)
      {
            const soap = '<?xml version="1.0" encoding="utf-8"?>\n' +
            '<s:Envelope xmlns:s="http://schemas.xmlsoap.org/soap/envelope/">\n' +
              '<s:Body>\n' + xml +
            '</s:Body>\n' +
            '</s:Envelope>\n'
            return soap
      },
      
      
      postXML()      
      {   

          this.msg.title = ''
          this.bt_spinner = true
          const url = this.fiscalPrinter.url
          const soap = this.getSOAP(this.getXML())
          axios({
               
               url    : url + '/cgi-bin/fpmate.cgi',
               method : 'post',
               data   : soap

             }).then(res => {
                this.bt_spinner = false
                console.log('RT Response',res)
                this.updateFiscalPrintStatus(this.coupon[0][0].couponId)
                this.closeModal()
                
             }).catch(err => {
                
                this.bt_spinner   = false   
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = err
                this.msg.type  = 1                          

               console.log('Errore Fiscal Printer ',err)  
             })
       
      }, 

      async updateFiscalPrintStatus(couponId)
      {
            
            const sp       = {'sp'       :'spUpdateFiscalPrintStatus'}      
            const data     = {'type'     : 'coupon','Id': couponId }
            const json     = Object.assign(data, sp);

            await api.post(json).then(res =>{
              if(res.status==200)
              {
            
                  //console.log(res)

              }
              else if(res.status==500)
              {
                console.log(res.data)
              }
              else
              {
                console.log(res)
              }
                                  
                    
          })
        },
         
   
     } 
      

    
  }
</script>
<style scoped>


.modal-footer {  
  justify-content: space-between;  
}


 
  h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
}
.modal-content
{
  width:  500px;
}
.form-check-label
{
  cursor: pointer;
}

</style>
